module.exports = __webpack_public_path__ + "img/bg05.8b3bef66.jpg";